import React from 'react';
import { useSeo } from '../hooks/useSeo';
import { FinalContact } from '../components/FinalContact';
export function Contact() {
  useSeo({
    title: 'Contact FSG Transport | Dispatch & Back Office Support',
    description: 'Contact FSG Transport about U.S.-based dispatch, load planning, broker setup, paperwork, billing, and back-office support. Call 234-602-8424 or send a message.',
    path: '/contact'
  });
  return <div className="w-full pt-20" data-id="element-423">
      <FinalContact data-id="element-424" />
    </div>;
}